import { useMegaMenuQuery } from 'framework/rest/menu/use-mega-menu.query';
import { FC } from 'react';
import NavigationItem from './NavigationItem';

interface Props {
    className?: string;
}

const Navigation: FC<Props> = ({ className = 'flex' }) => {
    const { data: megamenu, isLoading } = useMegaMenuQuery();

    if (isLoading) return <div></div>;

    return (
        <ul className={`nc-Navigation items-center ${className}`}>
            {megamenu
                ?.filter((x: any) => !!x?.is_active)
                .map((item: any) => (
                    <NavigationItem
                        key={item.id}
                        menuItem={{
                            ...item,
                            type: item?.children?.length ? 'megaMenu' : 'none',
                            children: item.children,
                        }}
                    />
                ))}
        </ul>
    );
};

export default Navigation;
